<template>
  <kendo-dialog
    ref="dialog"
    :modal="true"
    :width="300"
    :title="'Confirm Remove'"
    :visible="myUsername"
  >
    Are you sure that you want to remove it ?
    <kendo-dialog-action :text="'Yes'" :action="actionMethod"></kendo-dialog-action>
    <kendo-dialog-action :text="'Cancel'" :primary="true"></kendo-dialog-action>
  </kendo-dialog>
</template>
 
<script>
export default {
  props: {
    myUsername: Boolean
  },
  // ,  watch: {
  //     dataItem: function(newVal) {
  //       this.item = newVal;
  //     }
  //   },
  //   mounted() {
  //     this.openWindow();
  //     console.log("dd", this.openWindow());
  //   },
  methods: {
    actionMethod() {
      console.log("You chose to Push Now!", this.item);
      this.$emit("OkMethod", { dataItem: this.item });
    },
    openWindow() {
      this.$refs.dialog.kendoWidget().open();
    }
  },
  data: function() {
    return {
      item: { ...this.dataItems }
    };
  }
};
</script>
<style lang="scss">
.k-window-actions.k-dialog-actions {
  display: none;
}
</style>